module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/electric/shutdown-d1f8dece29e9c27032b70382e75a2e41.svg";